
import { useCallback } from 'react';

export const useAttendanceStats = () => {
  const getAttendanceStats = useCallback((teachers: any[]) => {
    const total = teachers.length;
    const present = teachers.filter(t => t.attendanceStatus === 'present').length;
    const absent = teachers.filter(t => t.attendanceStatus === 'absent').length;
    const late = teachers.filter(t => t.attendanceStatus === 'late').length;
    
    return {
      total,
      present,
      absent,
      late,
      presentPercentage: total ? Math.round((present / total) * 100) : 0,
      absentPercentage: total ? Math.round((absent / total) * 100) : 0,
      latePercentage: total ? Math.round((late / total) * 100) : 0,
    };
  }, []);

  return {
    getAttendanceStats
  };
};
